export const FIELD_TYPES = {
  basketball: "basketball",
  volleyball: "volleyball",
  tennis: "tennis",
  multisport: "multisport",
};

export const SIZE_OPTIONS = {
  [FIELD_TYPES.multisport]: ["14x15", "20x10", "32x15", "36x18"],
  [FIELD_TYPES.tennis]: ["28x15", "32x15", "36x18"],
  [FIELD_TYPES.volleyball]: ["20x10", "28x15", "32x15", "36x18"],
  [FIELD_TYPES.basketball]: [
    "8x7",
    "10x8",
    "12x10",
    "10x20",
    "14x15",
    "20x10",
    "28x15",
    "32x15",
    "36x18",
  ],
};
export const LANGUAGES = {
  pl: "pl",
  en: "en",
};
export const COMMON_INITIAL_VALUES = { unihockey: 2 };
export const INITIAL_VALUES = {
  [FIELD_TYPES.multisport]: {
    arena: true,
    wicketArena: true,
    basketballOne: true,
    basketballTwo: true,
    color: "#004333",
    tennisColor: "#0073b6",
    volleyballLines: true,
  },
  [FIELD_TYPES.tennis]: {
    net: true,
    tennisLines: true,
    volleyballNet: false,
    tennisColor: "#658159",
    color: "#004333",
  },
  [FIELD_TYPES.volleyball]: {
    volleyballNet: true,
    volleyballLines: true,
    volleyballColor: "#0073b6",
    color: "#d53132",
  },
  [FIELD_TYPES.basketball]: {
    basketballOne: true,
    basketballTwo: true,
    tennisLines: true,
    color: "#004333",
  },
};

export const convertSize = size => {
  if (!size) {
    return { x: 0, y: 0 };
  }
  const [xstr, ystr] = size.split("x");
  return { x: parseInt(xstr, 10), y: parseInt(ystr, 10) };
};
